<!-- src/components/common/MarqueUltraLink.vue -->
<!--
  La marque UltraLINK, la même que dans l'app mobile (kit du 05/10/2026,
  src/assets/images/marque/) : monogramme « UL » blanc fin sur le bleu marine du logo, nom
  « UltraLINK », signature facultative « by Ultra Secure ».

  Le monogramme est dessiné ICI plutôt qu'affiché par <img src=".svg"> : une image SVG ne peut
  pas charger la police de la page, son « UL » partirait dans une police de secours. En ligne, il
  prend l'Inter de la webapp et reste net à toute taille.

  `fond` : 'marine' (barre latérale) ou 'clair'. `sousTitre` : par exemple « Administration ».
-->
<template>
  <div class="flex items-center gap-3">
    <svg :width="taille" :height="taille" viewBox="0 0 512 512" aria-hidden="true" class="flex-shrink-0">
      <path d="M35.84,0 H353.28 A158.72,158.72 0 0 1 512,158.72 V476.16 A35.84,35.84 0 0 1 476.16,512 H158.72 A158.72,158.72 0 0 1 0,353.28 V35.84 A35.84,35.84 0 0 1 35.84,0 Z" fill="#0b2e40"/>
      <path d="M93.08,66.56 H327.99 A117.45,117.45 0 0 1 445.44,184.01 V418.92 A26.52,26.52 0 0 1 418.92,445.44 H184.01 A117.45,117.45 0 0 1 66.56,327.99 V93.08 A26.52,26.52 0 0 1 93.08,66.56 Z" fill="#163f55"/>
      <text x="256" y="256" font-family="Inter, sans-serif" font-weight="300" font-size="199.68" fill="#ffffff"
            text-anchor="middle" dominant-baseline="central" letter-spacing="-4.096">UL</text>
    </svg>
    <div class="min-w-0 leading-tight">
      <div class="font-semibold tracking-wide" :class="[fond === 'marine' ? 'text-white' : 'text-primary-600', tailleNom]">UltraLINK</div>
      <div v-if="signature" class="text-xs" :class="fond === 'marine' ? 'text-white/75' : 'text-gray-600'">by Ultra Secure</div>
      <div v-if="sousTitre" class="text-xs" :class="fond === 'marine' ? 'text-primary-200' : 'text-gray-500'">{{ sousTitre }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MarqueUltraLink',
  props: {
    taille: { type: Number, default: 36 },
    fond: { type: String, default: 'clair' },
    signature: { type: Boolean, default: false },
    sousTitre: { type: String, default: '' },
    tailleNom: { type: String, default: 'text-lg' }
  }
};
</script>
